import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from '../market';

const REVIEW_PRICE = 350;
const WARRANTY_HOURS = 168;

const CHAIN_PRICE = 24;
const CHAIN_ACTION_PRICE = 3.5;

export const YANDEXMAPS_FAQ = [
  {
    title: 'Что такое Boostclick и как работает сервис?',
    isH3: true,
    text: (
      <p>
        <b>Boostclick</b> — это платформа, где можно разместить задание для получения обратной связи от реальных пользователей. 
        <br />
        Вы описываете, что именно нужно протестировать (услугу, сайт, процесс коммуникации и т.п.), а исполнители выполняют задание удаленно, на основе личного опыта, и оставляют отзыв, например, на Яндекс* Картах.
        <br />
        <br />
        Платформа не размещает отзывы от вашего имени, не гарантирует положительные оценки и не использует шаблоны.
        <br />
        Только живой опыт, только честные мнения.
      </p>
    ),
  },
  {
    title: 'Как проходит удаленное тестирование?',
    isH3: true,
    text:
      <div>
        Исполнитель получает задание и:
        <br />
        <br />
        <ol>
          <li>Изучает карточку вашей компании на Яндекс* Картах;</li>
          <li>Посещает сайт или связывается с вами удаленно (по телефону, в чате, через форму);</li>
          <li>Оценивает удобство, вежливость, скорость ответа, оформление и т.д.;</li>
          <li>Пишет отзыв, основываясь исключительно на том, что было реально протестировано удаленно.</li>
        </ol>
        <br />
        Если взаимодействия не было, отзыв не публикуется. Это обязательное условие.
      </div>
  },
  {
    title: 'Пример реального отзыва на основе удаленного взаимодействия:',
    isH3: false,
    text: (
      <p>
        «Связался с компанией через чат на сайте — ответили в течение 5 минут. Консультант вежливо объяснил условия доставки и предложил несколько вариантов. Пока заказ не оформлял, но впечатление осталось положительное.»
      </p>
    ),
  },
  {
    title: 'Что нельзя писать в отзыве?',
    isH3: false,
    text: (
      <ul>
        <li>Упоминать визит в офис или магазин, если его не было;</li>
        <li>Давать оценку товару, который не тестировался;</li>
        <li>Использовать шаблонные фразы типа «лучшее место в городе» без подтвержденного опыта;</li>
        <li>Копировать заранее подготовленный текст от заказчика — это запрещено.</li>
      </ul>
    ),
  },
  {
    title: 'Почему стоит использовать обратную связь от тестировщиков?',
    isH3: false,
    text: (
      <ul>
        <li>Это отзывы от реальных пользователей;</li>
        <li>Основаны на личном опыте;</li>
        <li>Честные мнения воспринимаются доверительнее;</li>
        <li>Обычно проходят модерацию быстрее, чем рекламные тексты;</li>
        <li>Вы получаете отчет и можете запросить замену, если условия задания не соблюдены.</li>
      </ul>
    ),
  },
  {
    title: 'Сколько времени занимает размещение отзыва?',
    isH3: false,
    text: (
      <ul>
        <li>Исполнитель выполняет задание в течение 24 часов;</li>
        <li>После публикации отзыв проходит модерацию Яндекс* (до 68 часов);</li>
        <li>Весь процесс занимает от 3 до 7 дней.</li>
      </ul>
    ),
  },
  {
    title: 'Какие гарантии предоставляет Boostclick?',
    isH3: false,
    text: (
      <ul>
        <li>Мы предоставляем инструменты для контроля качества;</li>
        <li>У вас есть 72 часа на проверку результата;</li>
        <li>Если отзыв не опубликован или не соответствует условиям, можно запросить переделку;</li>
        <li>Boostclick не влияет на модерацию Яндекса* и не гарантирует размещение — только живой процесс.</li>
      </ul>
    ),
  },
  {
    title: 'Можно ли заранее написать отзыв и попросить исполнителя разместить его?',
    isH3: false,
    text: (
      <p>
        Нет. Это против правил.
        <br />
        <br />
        Отзыв должен быть результатом личного опыта пользователя.
        <br />
        Вы можете задать направление (на что обратить внимание), но текст должен быть написан исполнителем. 
        <br />
        Мы следим за соблюдением этого принципа.
      </p>
    ),
  },
  {
    title: 'Вы работаете с юридическими лицами?',
    isH3: false,
    text: (
      <p>
        Да. Мы предоставляем акты, счета и закрывающие документы через ЭДО.
      </p>
    ),
  },
  {
    title: 'Вы работаете с физическими лицами?',
    isH3: false,
    text: (
      <p>
        Да. Оплата через Робокассу, чек автоматически отправляется на ваш e-mail.
      </p>
    ),
  },
  {
    title: 'Важно знать (SEO-блок — аккуратно):',
    isH3: false,
    text: (
      <p>
        Ищете, как «накрутить отзывы на Яндекс* Картах»?
        <br />
        Boostclick — не накрутка, а платформа для честного взаимодействия с пользователями. Отзывы основаны на личном опыте исполнителей и проходят через реальные аккаунты. Это безопасный и этичный способ получить обратную связь.
      </p>
    ),
  },
];

const STEP_TWO_TITLE_FAQ = (
  <p>
    Почему при добавлении одного действия в калькуляторе появляются
    дополнительные действия?
    <br />
    <br />
    Сервис формирует уникальные сценарии для каждого исполнителя, и каждый
    сценарий начинается для нового исполнителя с поиска организации / места по сделанному
    скриншоту вашей ссылки.
  </p>
);

const ACTIONS = [
  {
    type: 'MAIN.REVIEW',
    icon: "message", 
    iconHome: "home-reviews",
    title: 'Написать отзыв о бесплатной услуге',
    titleComment: '(полное тестирование вашей услуги)',
    initialShare: 0,
    price: `от ${REVIEW_PRICE}`,
    itemTitle: 'тест+отзыв',
    activityType: 'Отзыв', // NOTE: do not change (see PopupStore.js abd ReportModal.jsx)
  },

  { type: 'ALWAYS.OPEN', icon: "open", iconHome: "home-open", title: 'Открыть Яндекс Карты / Поиск Яндекс', initialShare: 1 },
  { type: 'ALWAYS.SEARCH', icon: "search", iconHome: "home-search", title: 'Написать поисковый запрос', initialShare: 1 },
  { type: 'ALWAYS.FIND', icon: "search", iconHome: "home-search", title: 'Найти профиль', initialShare: 1 },
  { type: "ALWAYS.FEEDBACKS", icon: "glasses", iconHome: "home-glasses", title: "Прочитать отзывы", initialShare: 1 },

  {
    type: 'EXTRA.LIKE',
    icon: "like", 
    iconHome: "home-like",
    title: 'Поставить «Полезно» на последний положительный отзыв',
    initialShare: 0,
    activityType: 'Лайк',
  },
  {
    type: 'EXTRA.DISLIKE',
    icon: "dislike", 
    iconHome: "home-dislike",
    title: 'Поставить «Бесполезно» на последний отрицательный отзыв',
    initialShare: 0,
    activityType: 'Дизлайк',
    hidden: true,
  },

  { type: 'EXTRA.MEDIA', icon: "glasses", iconHome: "home-glasses", title: 'Просмотреть все фото и видео', initialShare: 0.5 },
  { type: "EXTRA.DESCRIPTION", icon: "glasses", iconHome: "home-glasses", title: "Прочитать полное описание", initialShare: 0.5 },

  {
    type: 'MAIN.CLICK',
    icon: "click",
    iconHome: "home-click",
    title: 'Перейти на сайт компании',
    initialShare: 0.2,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Переход',
  },

  {
    type: 'MAIN.ABOUT',
    icon: "glasses",
    iconHome: "home-glasses",
    title: 'Просмотреть «Особенности»',
    initialShare: 0.1,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Инфо',
  },

  {
    type: 'MAIN.ROUTE',
    icon: "click",
    iconHome: "home-click",
    title: 'Построить маршрут до места / клик «Маршрут»',
    initialShare: 0.2,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Маршрут',
  },

  {
    type: 'MAIN.PHONE',
    icon: "click",
    iconHome: "home-click",
    title: 'Нажать «Показать номер»',
    initialShare: 0.2,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Телефон',
  },

  {
    type: 'MAIN.FAVORITE',
    icon: "heart",
    iconHome: "home-heart",
    title: 'Сохранить компанию в избранное',
    initialShare: 0.3,
    price: CHAIN_ACTION_PRICE,
    activityType: 'Избранное',
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Поведенческая активность",
    path: "/povedencheskie-faktory-na-yandexmaps",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: "home-reviews",
    title: "Оставить отзыв",
    path: "/reviews-on-yandexmaps",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: "home-reviews",
    title: "Отзыв об услуге",
    path: "/povedencheskie-faktory-na-yandexmaps",
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Открыть Яндекс Карты*",
    path: "/povedencheskie-faktory-na-yandexmaps",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Поисковый запрос",
    path: "/povedencheskie-faktory-na-yandexmaps",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти компанию",
    path: "/povedencheskie-faktory-na-yandexmaps",
    target: '_self',
  },
  {
    iconHome: "home-book",
    title: "Прочитать отзывы",
    path: "/povedencheskie-faktory-na-yandexmaps",
    target: '_self',
  },
  {
    iconHome: "home-like",
    title: "Оценить отзыв",
    path: "/povedencheskie-faktory-na-yandexmaps",
    target: '_self',
  },
  {
    iconHome: "home-magic",
    title: "Генерация отзыва от GPT",
    // titleComment: "не пишите сами — GPT сделает это за вас",
    path: 'https://ai.boostclick.ru/',
    target: '_blank',
    isGPT: true
  }
];

const LIST_ONLINE_SERVICES = [
  {
    title: "Своя услуга",
  },
  {
    title: "Диагностика ноутбука / ПК",
    text: "Тестировщик получает удаленную консультацию и диагностику",
  },
  {
    title: "Диагностика автомобиля",
    text: "Тестировщик получает удаленную консультацию и рекомендации",
  },
  {
    title: "Онлайн-консультация стилиста",
    text: "Тестировщик описывает свой стиль и  получает рекомендации",
  },
  {
    title: "Дизайн-проект одной комнаты / зоны",
    text: "Тестировщик предоставляет размеры, фотографии, получает эскиз расстановки мебели",
  },
  {
    title: "Подбор ухода за кожей / ароматов",
    text: "Тестировщик проходит онлайн-опрос и получает рекомендации",
  },
  {
    title: "Консультация по тренировкам / питанию",
    text: "Тестировщик описывает свои цели и получает базовые рекомендации",
  },
  {
    title: "Оценка стоимости ювелирных изделий по фото",
    text: "Тестировщик присылает фото и получает примерную оценку",
  },
  {
    title: "Онлайн-подбор тура (без бронирования)",
    text: "Тестировщик описывает пожелания и получает варианты туров",
  },
  {
    title: "Обработка одного фото / видео до 30s",
    text: "Тестировщик присылает исходник и получает обработанный вариант",
  },
  {
    title: "Расчет сметы на ремонт по предоставленным размерам",
    text: "Тестировщик присылает замеры помещения и получает расчет",
  },
  {
    title: "Другое (укажите свою услугу)",
  },
];

const STEP_PHRASE_2 = 'Укажите информацию для поиска компании на Яндекс Картах';

const YANDEXMAPS_KEYWORDS = [
  'Яндекс Карты', 'Yandex Maps', 'Yandex Карты', 'Яндекс Maps', 'Я.Карты'
];

class YandexMapsClass extends Market {

  id = 'yandexmaps';
  host = 'yandex.ru';
  hostsList = [
    'yandex.ru',
    'yandex.org',
    'yandex.net',
    'yandex.net.ru',
    'yandex.com.ru',
    'yandex.by',
    'yandex.eu',
    'yandex.ee',
    'yandex.lt',
    'yandex.lv',
    'yandex.md',
    'yandex.uz',
    'yandex.tm',
    'yandex.de',
    'yandex.nu',
    'yandex.tj',
    'yandex.az',
    'ya.ru',
    'yandex.com',
    'yandex.asia',
    'yandex.mobi',
    'maps.yandex.ru'
  ];
  url = 'https://yandex.ru/maps/';

  title = 'Яндекс.Карты*';

  isMarketplace = false;
  isMaps = true;

  icon = "yandexmap";
  titlePlaces = 'Яндекс.Карты*';
  statusForHomePage = MARKET_MODE_STATUS.NEW;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [
    { "type": "Еда" },
    { "type": "Продукты" },
    { "type": "Медицина" },
    { "type": "Магазины" },
    { "type": "Авто" },
    { "type": "Красота" },
    { "type": "Стройка и ремонт" },
    { "type": "Государство" },
    { "type": "Почта" },
    { "type": "Банки и финансы" },
    { "type": "Услуги" },
    { "type": "Транспорт" },
    { "type": "Развлечения и отдых" },
    { "type": "Туризм" },
    { "type": "Образование" },
    { "type": "Спорт" },
    { "type": "Домашние животные" },
    { "type": "Прочее" },
  ];

  chainsPerDayNormal = 200 / 30;

  chainPrice = CHAIN_PRICE;
  chainsMin = 4;
  chainsMax = 250;

  chainsDefault = 10;

  reviewPrice = REVIEW_PRICE;

  chainsStep = 1;
  viewsStep = 10;

  keywords = YANDEXMAPS_KEYWORDS;

  targetLinkComment = 'Укажите тут ссылку вашей компании на Яндекс Картах';
  targetLinkCommentShort = 'Укажите ссылку компании';

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: '/povedencheskie-faktory-na-yandexmaps',
      rating: 0.9689,
      title: 'ПФ Яндекс Карты*',
      navigateTitle: 'ПФ действия на картах',
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.REGULAR,
      meta: {
        title: `Накрутка ПФ ЛЮДИ на Яндекс Картах – от 1 руб. | Boostclick`,
        description: `Закажите накрутку ПФ ЛЮДИ на Яндекс Картах от ${CHAIN_PRICE} руб. — отзывы, просмотры.`,
        canonical: '/povedencheskie-faktory-na-yandexmaps',
      },
      intro: {
        title: 'Продвижение через ПФ на Яндекс Картах',
        comment: 'Через выполнение микрозадач от реальных пользователей',
        points: [
          'Увеличит просмотры и активность',
          'Оптимизирует расходы на рекламу',
          'Улучшит позиции в поиске',
        ]
      },
      howItWorks: [
        /* 'Настройте параметры активности в соответствии с конкуренцией',
        'Укажите ссылку на карточку компании для скриншота',
        'Укажите категорию, город и ключевые фразы из карточки компании',
        'После оплаты мы передадим исполнителю скриншот и параметры для поиска',
        'Проверьте ответы и активность, примите работу или отправьте на доработку' */
      ],
      stepPhrase1: 'Настройте стоимость ПФ на Яндекс Картах и параметры',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Заказать ПФ на Яндекс Картах',
      titleFAQ: 'Вопрос-ответ по накрутке ПФ на Яндекс Картах',
      faq: YANDEXMAPS_FAQ,
      actions: (() => {
        return [
          ...ACTIONS.filter(action => action.type === 'MAIN.REVIEW'),
          ...ACTIONS.filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.')),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'При написании отзывов тестировщики полностью проходят путь пользователя от органического поиска до просмотра услуг / контактов.',
        'Каждый тестировщик получает индивидуальное задание — поэтому разное поведение пользователей на карточке вашей компании.',
        'В первую очередь будут выполняться действия связанные с органическим поиском и изучением информации о месте, далее просмотр отзывов и услуг. В последнюю очередь делаются действия с контактными данными.',
        'Сложность цепочек и время исполнения зависит от их количества в проекте',
      ]
    },
    {
      id: MARKET_MODES.REVIEWS,
      path: '/reviews-on-yandexmaps',
      rating: 0.969,
      title: 'Отзывы',
      navigateTitle: 'Отзывы от пользователей на картах',
      icon: "message",
      iconForHomePage: "home-reviews",
      status: MARKET_MODE_STATUS.REGULAR,
      meta: {
        title: `Отзывы на Яндекс Картах от ${REVIEW_PRICE} руб. — заказать от ЛЮДЕЙ | Boostclick`,
        description: `Отзывы ЛЮДИ на Яндекс Картах — закажите через Boostclick.`,
        canonical: '/reviews-on-yandexmaps',
      },
      intro: {
        title: `Получить обратную связь на Яндекс* Картах`,
        comment: 'Тестирование вашей компании или услуги реальными пользователями',
        points: [
          'Отзывы от независимых пользователей, прошедших тест услуги',
          'Гарантия выполнения задания от исполнителя',
          'Электронный чек после оплаты',
          `Оплата только после выполнения задания (до ${WARRANTY_HOURS} часов)`,
          'Подходит для любых сфер и регионов',
        ]
      },
      howItWorks: [
        /* 'Настройте параметры активности в соответствии с конкуренцией',
        'Укажите ссылку на карточку компании для скриншота',
        'Укажите категорию, город и ключевые фразы из карточки компании',
        'После оплаты мы передадим исполнителю скриншот и параметры для поиска',
        'Проверьте ответы и активность, примите работу или отправьте на доработку' */
      ],
      stepPhrase1: 'Настройте параметры задания на Яндекс* Картах',
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: 'Получение обратной связи о вашем бизнесе от реальных пользователей',
      titleFAQ: "Частые вопросы о получении обратной связи на Яндекс* Картах",
      faq: YANDEXMAPS_FAQ,
      listOnlineServices: LIST_ONLINE_SERVICES,
      actions: (() => {
        return [
          ...ACTIONS.filter(action => action.type === 'MAIN.REVIEW'),
          ...ACTIONS.filter(action => action.type !== 'MAIN.REVIEW' && !action.type.startsWith('VIEW.')),
        ];
      })(),
      notice: [
        '* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов',
        'Сложность цепочек и время исполнения зависит от их количества в проекте',
      ]
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action; return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку вашей компании на картах';
  invalidUrlStr = 'Укажите корректную ссылку на вашу компанию';
}

const YandexMaps = new YandexMapsClass();
export default YandexMaps;
